
import Vue from "vue";

export default Vue.extend({
	props: {
		xs: [Number, String],
		sm: [Number, String],
		md: [Number, String],
		lg: [Number, String],
		xl: [Number, String],
		auto: Boolean,
		right: Boolean,
		center: Boolean,
		backgroundColor: String,
		noMargin: Boolean,
		block: Boolean,
		grow: Boolean,
		shrink: Boolean,
		reverse: Boolean,
		row: Boolean,
		widthTransition: Boolean,
		defaultWidth: {
			type: Number,
			default: 12
		}
	},
	computed: {
		_xs():string {
			return "xs-" + (this.xs || this.defaultWidth);
		},
		_sm():string {
			return "sm-" + (this.sm  || this.xs || this.defaultWidth);
		},
		_md():string {
			return "md-" + (this.md || this.sm || this.xs || this.defaultWidth);
		},
		_lg():string {
			return "lg-" + (this.lg || this.md || this.sm || this.xs || this.defaultWidth);
		},
		_xl():string {
			return "xl-" + (this.xl || this.lg || this.md || this.sm || this.xs || this.defaultWidth);
		},
		classes():string[] {
			let result = [this._xs, this._sm, this._md, this._lg, this._xl];
			if (this.right) {
				result.push("right");
			}
			if (this.center) {
				result.push("center");
			}
			if (this.noMargin) {
				result.push("no-margin");
			}
			if (this.block) {
				result.push("block");
			}
			if (this.auto) {
				result.push("auto");
			}
			if (this.grow) {
				result.push("grow");
			}
			if (this.shrink) {
				result.push("shrink");
			}
			if (this.reverse){
				result.push("reverse");
			}
			if (this.row){
				result.push("flex-row");
			}
			if (this.widthTransition){
				result.push("transition");
			}
			return result;
		}
	},
})
;